import { Text } from "@/elements"
import clsx from "clsx"
import React, { FC } from "react"

interface Props {
  title: string
  onClick: () => void
  color?: "black" | "red"
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

export const DialogMenuButton: FC<Props> = ({ title, Icon, onClick, color = "black" }) => {
  return (
    <div className="flex h-[60px] w-full py-2">
      <div
        className="flex h-full w-full cursor-pointer flex-row items-center justify-center rounded-md hover:bg-bg-2"
        onClick={onClick}>
        {Icon && (
          <Icon
            height={22}
            width={22}
            className={clsx("mr-2 flex flex-shrink-0", color === "black" ? "stroke-fg-1" : "stroke-red-default")}
          />
        )}
        <Text className={color === "black" ? "text-fg-1" : "text-red-default"}>{title}</Text>
      </div>
    </div>
  )
}
